import React from 'react';
import { Section, HeadingItem } from '@atlaskit/side-navigation';
import { ScreenReaderText } from '@atlassian/jira-accessibility/src/common/ui/screenreader-text/index.tsx';
import type { Props } from './types.tsx';

export const SectionWithHeader = ({
	title,
	headingLevel,
	headingItemProps,
	sectionProps,
	children,
	screenReaderTextHeading,
}: Props) => {
	const commonHeadingItem = (
		<HeadingItem headingLevel={headingLevel} {...headingItemProps}>
			{title}
		</HeadingItem>
	);

	return (
		<Section {...sectionProps}>
			{title &&
				(screenReaderTextHeading ? (
					<ScreenReaderText>{commonHeadingItem}</ScreenReaderText>
				) : (
					commonHeadingItem
				))}
			{children}
		</Section>
	);
};
